import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../_services/auth.service';
import { Globals } from '../../_globals';
import { CookieService } from 'ngx-cookie-service';
import { StoreService } from '../../_services/store.service';
import { ConfirmationService } from 'primeng/api';
import { StoreContextService } from '../../_services/store-context.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-select-store',
    templateUrl: './select-store.component.html',
    styleUrls: ['./select-store.component.css']
})
export class SelectStoreComponent implements OnInit {

    stores: any[] = [];
    selectedStore: any;
    routeRole: any;

    constructor(
        public _authService: AuthService,
        public globals: Globals,
        public cookieService: CookieService,
        public _storeService: StoreService,
        public confirmationService: ConfirmationService,
        public _storeContextService: StoreContextService,
        public router: Router
    ) {
        this.routeRole = globals.user.routeRole;
    }

    ngOnInit() {
        this.getAllStores();
    }

    // Get all valid stores for current user
    public getAllStores() {
        this._storeService.getAllStoresNoPagination()
            .subscribe((data: any) => {
                this.stores = data;
                if (this.stores.length && this.stores.length === 1) {
                    console.log('should automatically go to store');
                    this.goToStore(this.stores[0]);
                }
            });
    }

    // Handle onRowSelect to prompt confirmation of choosing store
    public onRowSelect(event) {
        // console.log(event);
        this.selectedStore = event.data;
        this.confirmationService.confirm({
            message: 'Are you sure that you want to select this store?',
            accept: () => {
                // Actual logic to perform a confirmation
                this.goToStore(this.selectedStore);
            }
        });
    }


    goToStore(store) {

        // Actual logic to perform a confirmation
        this.cookieService.set('currentStore', JSON.stringify(store), null, '/');
        this.globals.store.name = store.name;
        this.globals.store.id = store.id;
        this._storeContextService.emitStoreChanged(store);
        // this.router.navigate(['/' + this.routeRole + '/store/details'])
        this.router.navigate(['/' + this.routeRole + '/dashboard'])

    }




}



// WEBPACK FOOTER //
// ./src/app/components/select-store/select-store.component.ts